import { render, staticRenderFns } from "./AgendaDeleteConfirmationModal.vue?vue&type=template&id=4d076ef8&"
import script from "./AgendaDeleteConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./AgendaDeleteConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports